export default [
    { cutoff: '', show: 'April 6, 1947' },
    { cutoff: '', show: 'March 28, 1948' },
    { cutoff: '', show: 'April 29, 1949' },
    { cutoff: '', show: 'April 9, 1950' },
    { cutoff: '', show: 'March 25, 1951' },
    { cutoff: '', show: 'March 30, 1952' },
    { cutoff: '', show: 'March 29, 1953' },
    { cutoff: '', show: 'March 28, 1954' },
    { cutoff: '', show: 'March 27, 1955' },
    { cutoff: '', show: 'April 1, 1956' },
    { cutoff: '', show: 'April 21, 1957' },
    { cutoff: '', show: 'April 13, 1958' },
    { cutoff: '', show: 'April 12, 1959' },
    { cutoff: '', show: 'April 24, 1960' },
    { cutoff: '', show: 'April 16, 1961' },
    { cutoff: '', show: 'April 29, 1962' },
    { cutoff: '', show: 'April 28, 1963' },
    { cutoff: '', show: 'May 24, 1964' },
    { cutoff: '', show: 'June 13, 1965' },
    { cutoff: '', show: 'June 16, 1966' },
    { cutoff: '', show: 'March 26, 1967' },
    { cutoff: '', show: 'April 21, 1968' },
    { cutoff: '', show: 'April 20, 1969' },
    { cutoff: '', show: 'April 19, 1970' },
    { cutoff: '', show: 'March 28, 1971' },
    { cutoff: '', show: 'April 23, 1972' },
    { cutoff: '', show: 'March 25, 1973' },
    { cutoff: '', show: 'April 21, 1974' },
    { cutoff: '', show: 'April 20, 1975' },
    { cutoff: '', show: 'April 18, 1976' },
    { cutoff: '', show: 'June 5, 1977' },
    { cutoff: '', show: 'June 4, 1978' },
    { cutoff: '', show: 'June 3, 1979' },
    { cutoff: '', show: 'June 8, 1980' },
    { cutoff: '', show: 'June 7, 1981' },
    { cutoff: '', show: 'June 6, 1982' },
    { cutoff: '', show: 'June 5, 1983' },
    {
        show: 'June 3, 1984',
        nominationAnnouncements: 'May 7, 1984',
        cutoff: '',
    },
    {
        show: 'June 2, 1985',
        nominationAnnouncements: 'May 6, 1985',
        cutoff: '',
    },
    {
        show: 'June 1, 1986',
        nominationAnnouncements: 'May 8, 1986',
        cutoff: '',
    },
    {
        show: 'June 7, 1987',
        nominationAnnouncements: 'May 11, 1987',
        cutoff: '',
    },
    {
        show: 'June 5, 1988',
        nominationAnnouncements: 'May 9, 1988',
        cutoff: '',
    },
    {
        show: 'June 4, 1989',
        nominationAnnouncements: 'May 8, 1989',
        cutoff: 'May 3, 1989',
    },
    {
        show: 'June 3, 1990',
        nominationAnnouncements: 'May 7, 1990',
        cutoff: '',
    },
    {
        show: 'June 2, 1991',
        nominationAnnouncements: 'May 6, 1991',
        cutoff: '',
    },
    {
        show: 'May 31, 1992',
        nominationAnnouncements: 'May 4, 1992',
        cutoff: '',
    },
    {
        show: 'June 6, 1993',
        nominationAnnouncements: 'May 11, 1993',
        cutoff: '',
    },
    {
        show: 'June 12, 1994',
        nominationAnnouncements: 'May 16, 1994',
        cutoff: '',
    },
    {
        show: 'June 4, 1995',
        nominationAnnouncements: 'May 8, 1995',
        cutoff: '',
    },
    {
        show: 'June 2, 1996',
        nominationAnnouncements: 'May 6, 1996',
        cutoff: '',
    },
    {
        show: 'June 1, 1997',
        nominationAnnouncements: 'May 5, 1997',
        cutoff: '',
    },
    {
        show: 'June 7, 1998',
        nominationAnnouncements: 'May 4, 1998',
        cutoff: '',
    },
    {
        show: 'June 6, 1999',
        nominationAnnouncements: 'May 3, 1999',
        cutoff: '',
    },
    {
        show: 'June 4, 2000',
        nominationAnnouncements: 'May 8, 2000',
        cutoff: '',
    },
    {
        show: 'June 3, 2001',
        nominationAnnouncements: 'May 7, 2001',
        cutoff: '',
    },
    {
        show: 'June 2, 2002',
        nominationAnnouncements: 'May 6, 2002',
        cutoff: '',
    },
    {
        show: 'June 8, 2003',
        nominationAnnouncements: 'May 12, 2003',
        cutoff: '',
    },
    {
        show: 'June 6, 2004',
        nominationAnnouncements: 'May 10, 2004',
        cutoff: 'May 5, 2004',
    },
    {
        show: 'June 5, 2005',
        nominationAnnouncements: 'May 10, 2005',
        cutoff: 'May 4, 2005',
    },
    {
        show: 'June 11, 2006',
        nominationAnnouncements: 'May 16, 2006',
        cutoff: 'April 23, 2006',
    },
    {
        show: 'June 10, 2007',
        nominationAnnouncements: 'May 15, 2007',
        cutoff: 'May 9, 2007',
    },
    {
        show: 'June 15, 2008',
        nominationAnnouncements: 'May 13, 2008',
        cutoff: 'May 7, 2008',
    },
    {
        show: 'June 7, 2009',
        nominationAnnouncements: 'May 5, 2009',
        cutoff: 'April 30, 2009',
    },
    {
        show: 'June 13, 2010',
        nominationAnnouncements: 'May 4, 2010',
        cutoff: 'April 29, 2010',
    },
    {
        show: 'June 12, 2011',
        nominationAnnouncements: 'May 3, 2011',
        cutoff: 'April 28, 2011',
    },
    {
        show: 'June 10, 2012',
        nominationAnnouncements: 'May 1, 2012',
        cutoff: 'April 27, 2012',
    },
    {
        show: 'June 9, 2013',
        nominationAnnouncements: 'April 30, 2013',
        cutoff: 'April 25, 2013',
    },
    {
        cutoff: 'April 24, 2014',
        show: 'June 8, 2014',
        nominationAnnouncements: 'April 29, 2014',
    },
    {
        cutoff: 'April 23, 2015',
        show: 'June 7, 2015',
        nominationAnnouncements: 'April 28, 2015',
    },
    {
        cutoff: 'April 28, 2016',
        show: 'June 12, 2016',
        nominationAnnouncements: 'May 3, 2016',
    },
    {
        cutoff: 'April 27, 2017',
        show: 'June 11, 2017',
        nominationAnnouncements: 'May 2, 2017',
    },
    {
        cutoff: 'April 26, 2018',
        show: 'June 10, 2018',
        nominationAnnouncements: 'May 1, 2018',
    },
    {
        cutoff: 'April 25, 2019',
        show: 'June 9, 2019',
        nominationAnnouncements: 'April 30, 2019',
    },
    {
        cutoff: 'April 23, 2020',
        show: 'June 7, 2020',
        nominationAnnouncements: 'April 28, 2020',
    },
];
